module.exports = __webpack_public_path__ + "assets-cabinet/img/plus.3a9cfb7a.svg";